import { render, staticRenderFns } from "./ArchiveCaution.vue?vue&type=template&id=b7274aca&"
import script from "./ArchiveCaution.vue?vue&type=script&lang=js&"
export * from "./ArchiveCaution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports